<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3>Daily Consumption</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
                    <b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col>
								<b-form inline>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">From: </label>
										<b-form-datepicker v-model="datefrom" class="mr-sm-2" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
									</b-form-group>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
										<b-form-datepicker v-model="dateto" class="mr-sm-2" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"></b-form-datepicker>
									</b-form-group>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">To: </label>
										<b-form-select class="mr-sm-2" v-model="selectedItem.state" :options="$root.state_options" size="sm" @change="selectedItem.ulb=0" required></b-form-select>
									</b-form-group>
									<b-form-group>
										<label for="inline-form-input-name" class="mr-sm-2 justify-left">ULB: </label>
										<b-form-select v-model="selectedItem.ulb" :disabled="selectedItem.state == ''" :options="ulb_options" size="sm" @change="fetchDailyConsumption()" required>
											<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
											<b-form-select-option v-for="item in filterULB(zones)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
										</b-form-select>
									</b-form-group>
								</b-form>
							</b-col>
						</b-row>
						<b-row class="mt-4 px-3" v-if="records.length > 0">
							<b-col lg="3">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="6">
							</b-col>
							<b-col lg="3">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3" v-if="records.length > 0">
							<b-col lg="12">
								<b-table show-empty small striped responsive outlined id="my-table" sticky-header="true" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template #head()="scope">
										<div class="text-nowrap">
											{{ scope.label }}
										</div>
									</template>
									<template v-slot:cell(ulb_id)="row">
										<b-label>{{getUlbLabel(row.value)[0].title}}</b-label>
									</template>
                                    <template v-slot:cell(status)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3" v-if="records.length > 0">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
export default {
	name: 'Wards',
	components: {
		"top-header": Header
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
        this.loadzones();
		//this.initload();
	},
	data() {
		var self = this;
		return{
			loading: false, 
			email: '',
			password: '',
            zonesUrl: self.$session.get('apiurl')+'api/zone-list',
			recordUrl: self.$session.get('apiurl')+'api/zones',
			consumptionUrl: self.$session.get('apiurl')+'api/consumption',
			updateUrl: self.$session.get('apiurl')+'api/zone-edit',
			deleteUrl: self.$session.get('apiurl')+'api/zone-remove',
			datefrom: self.$moment().subtract(7,'day').format('YYYY-MM-DD'),
			dateto: self.$moment().format('YYYY-MM-DD'),
            zones: [],
			records: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			ulb_options: [],
			fields: [
				{ key: 'feeder_pillar_no', label: 'FP No.' },
				{ key: 'location', label: 'Location', stickyColumn: true, isRowHeader: true, variant: 'dark'},
                { key: 'no_of_fittings', label: 'No of Lights' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
                ulb_id: '',
				title: '',
				areacode: '',
				status: 0
			}
		};
	},
	methods: {
        getUlbLabel: function(value){
            return this.zones.filter(function (item) {
				return item.id  == value;
			})
        },
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.state  == self.selectedItem.state;
			})
		},
        fetchDailyConsumption(){
            var self = this;
            
            self.axios.post(this.consumptionUrl, {
				accesskey: self.$session.get('access_key'),
				ulb: self.selectedItem.ulb,
				datefrom: self.datefrom,
				dateto: self.dateto 
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var consumption = response.data.result.consumption;
                    var filter_consumption = new Object();
                    consumption.forEach(function(item){
                        if(filter_consumption[item.imei_no] == undefined){
                            filter_consumption[item.imei_no] = new Object();
                        }
                        filter_consumption[item.imei_no][item.update_time] = item.kwh;
					});
                    console.log('CONSUMPTION '+JSON.stringify(filter_consumption));

					var start_date = self.$moment(self.datefrom);
                    var end_date = self.$moment(self.dateto);
                    var next_date = self.$moment(start_date).add(1, 'day');
                    var _dates = [];
                    _dates.push(start_date.format('YYYY-MM-DD'));
                    
                    if(end_date.diff(start_date, 'days') != 0){
                        next_date = self.$moment(start_date).add(1, 'day');
                        while(end_date.diff(next_date, 'days')>0){
                            _dates.push(next_date.format('YYYY-MM-DD'));

                            next_date = self.$moment(next_date).add(1, 'day');
                        }
                        _dates.push(end_date.format('YYYY-MM-DD'));
                    }

                    var filter_devices = new Array();
                    var devices = response.data.result.devices;
                    devices.forEach(function(item){
                        var d = new Object();
                        d.imei_no = item.imei_no;
                        d.no_of_fittings = item.no_of_fittings;
                        d.feeder_pillar_no = item.feeder_pillar_no;
                        d.location = item.location;

                        var prev_date = '';
                        var prev_value = 0;
                        _dates.forEach(function(date){
                            //var date = self.$moment(_date).format('YYYY-MM-DD');
                            
                            var fc_data = filter_consumption[item.imei_no];
                            
                            if(fc_data){
                                if(fc_data[date]){
                                    d[date] = fc_data[date]/100;
                                    if(prev_value){
                                        if(d[date] > prev_value){
                                            d[prev_date+'-c'] = (d[date] - prev_value).toFixed(2);
                                        }else{
                                            d[prev_date+'-c'] = (d[date] + prev_value).toFixed(2);
                                        }
                                    }
                                    prev_date = date;
                                    prev_value = d[date];
                                }else{
                                    d[date] = '---';
                                }
                            }else{
                                d[date] = '---';
                            }
                        });
                        filter_devices.push(d);
					});
                    self.records = filter_devices;
                    self.totalRows = self.records.length;
				}

				var ctr = 0;
				self.fields = [];
				self.fields.push({ key: 'feeder_pillar_no', label: 'FP No.', stickyColumn: true, isRowHeader: true, variant: 'info' });
				self.fields.push({ key: 'location', label: 'Location', stickyColumn: true, isRowHeader: true, variant: 'dark', class:'m-w-250'});
                self.fields.push({ key: 'no_of_fittings', label: 'No of Lights' });
				_dates.forEach(function(date){
					ctr++;
					self.fields.push({'key': date, 'label': self.$moment(date).format('DD-MM-YYYY'), class: 'text-right'});
					if(_dates.length != ctr){
						self.fields.push({'key': date+'-c', 'label': '(C)', class: 'text-center'});
					}  
				})
				
			})
			.catch(function (error) {
				alert(error);
			});
        },
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-model');
		},
		showUpdateModal(item, index, button) {
			var self = this;
            this.selectedItem = Object.assign({}, item);
            
            var zoneinfo = self.zones.filter(function (zone) {
                console.log(item.ulb_id+" "+zone.id);
                if(item.ulb_id == zone.id){
                    return zone;
                }
            });
            
            this.selectedItem.state_id = zoneinfo[0].state;
			this.$root.$emit('bv::show::modal', 'my-model', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete Zone or ULB.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
        loadzones(){
            var self = this;
            
            self.axios.post(self.zonesUrl, {
                accesskey: self.$session.get('access_key')
            })
            .then(function (response) {
                if(response.data.error == 0 || response.data.error == '0'){
                    self.zones = response.data.result;


					var start_date = self.$moment(self.datefrom);
                    var end_date = self.$moment(self.dateto);
                    var next_date = self.$moment(start_date).add(1, 'day');
                    var _dates = [];
                    _dates.push(start_date.format('YYYY-MM-DD'));
                    
                    if(end_date.diff(start_date, 'days') != 0){
                        next_date = self.$moment(start_date).add(1, 'day');
                        while(end_date.diff(next_date, 'days')>0){
                            _dates.push(next_date.format('YYYY-MM-DD'));

                            next_date = self.$moment(next_date).add(1, 'day');
                        }
                        _dates.push(end_date.format('YYYY-MM-DD'));
                    }

					var ctr = 0;
                    _dates.forEach(function(date){
						ctr++;
                        self.fields.push({'key': date, 'label': self.$moment(date).format('DD-MM-YYYY'), class: 'text-right'});
                        if(_dates.length != ctr){
                            self.fields.push({'key': date+'-c', 'label': '(C)', class: 'text-center'});
                        }  
                    })
                                            
                }
            })
            .catch(function (error) {
                alert(error);
            });
        },
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);

					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;

					/*const zoneOptions = arr.reduce((acc, current) => {
						const x = acc.find(item => item.value === current.value);
						if (!x) {
							return acc.concat([current]);
						} else {
							return acc;
						}
					}, []);*/
					self.zoneOptions = [];
					self.records.forEach(function(item){
						if(item.parent == 0){
							self.zoneOptions.push({value:item.id, text:item.title, state:item.state});
						}
						
					});
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		/*filtercategory(records){
			var filterarr = new Array();
			records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
		},*/
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "daily_consumption_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>